import { Component, OnInit } from '@angular/core';
import { EmbeddableTileComponent } from '../../../interfaces/embeddable-tile-component';
import { ComponentDialogComponent } from '../../component-dialog/component-dialog.component';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { TextSubscription } from '../../../models/data/app-core/text-subscription';
import { AppService } from '../../../services/app.service';
import { MessageSeverity } from '../../../enums/message-severity';
import { ChatService } from '../../../services/chat/chat.service';
import { TextSubscriptionRegistrationResult } from '../../../models/net/result/text-subscription-registration-result';

@Component({
    selector: 'app-subscriber',
    templateUrl: './subscriber.component.html',
    styleUrls: ['./subscriber.component.css']
})

export class SubscriberComponent implements OnInit, EmbeddableTileComponent {

    private _phoneNumber: string = "";
    private _textSubscription: TextSubscription = new TextSubscription();

    public inversionFilter: string = "filter:invert(0%)";
    public setIsDataSourceAltered = new EventEmitter<boolean>();
    public pendingChangesStateChanged = new EventEmitter<boolean>();
    public setAcceptButtonCaption = new EventEmitter<string>();
    public setCloseButtonCaption = new EventEmitter<string>();
    public closeContainerRequest = new EventEmitter<void>();

    @Output() acceptClicked = new EventEmitter<void>();

    public get phoneNumber(): string {

        return this._phoneNumber;
    }

    public set phoneNumber(value: string) {

        this._phoneNumber = value;
        this.pendingChangesStateChanged.emit(true);
    }

    public constructor(public appService: AppService, private chatService: ChatService) {

        let themeName: string = this.appService.themeService.currentThemeName;

        if (themeName == "dark") {

            this.inversionFilter = "filter:invert(100%)";

        } else {

            this.inversionFilter = "filter:invert(0%)";
        }
    }

    public setDataSource(dataSource: any, componentDialogComponent: ComponentDialogComponent): void { }

    public ngOnInit(): void { }

    public subscribe = (): boolean => {

        let result: boolean = true;

        if (this._phoneNumber.length === 10) { // && /^\d+$/.test(this._phoneNumber)) {

            this._textSubscription.PhoneNumber = this._phoneNumber;

            this.chatService.registerTextSubscription(this._textSubscription).subscribe((r: TextSubscriptionRegistrationResult | null) => {

                if (r) {

                    if (r.IsSuccessfulInitialRegistration) {

                        result = true;
                        this.closeContainerRequest.emit();
                        this.appService.showDialog(MessageSeverity.Success, "Subscription Successful", "Thank you for subscribing to Lutz Angeles Newz and product updates.  To unsubscribe, reply STOP or HELP for more options", "", "CLOSE", false, false, false);

                    } else {

                        this.appService.showDialog(MessageSeverity.Error, "Not Subscribed", r.InitialRegistrationFailureReason!, "", "CANCEL", false, false, false);
                    }
                }
            });

        } else {

            this.appService.showDialog(MessageSeverity.Warning, "Invalid Phone Number", "The phone number entered " + this._phoneNumber + " is not a valid number.  Please check the number and try again.", "", "CANCEL", false, false, false);
        }

        return result;
    }

    public setValidPhoneNumber = (): boolean => {

        let result: boolean = false;

        if (this._phoneNumber.length === 10) { // && /^\d+$/.test(this._phoneNumber)) {

            this._textSubscription.PhoneNumber = this._phoneNumber;

            result = true;
        }

        return result;
    }

    // deprecated - used by the container to inform the content (this component) that the accept button was clicked - deprecating the container accept button 
    public validateBeforeAccept(): boolean {

        let result: boolean = true;

        if (this._phoneNumber.length === 10) { // && /^\d+$/.test(this._phoneNumber)) {

            this._textSubscription.PhoneNumber = this._phoneNumber;

            this.chatService.registerTextSubscription(this._textSubscription).subscribe((r: TextSubscriptionRegistrationResult | null) => {

                if (r) {

                    if (r.IsSuccessfulInitialRegistration) {

                        result = true;
                        this.closeContainerRequest.emit();
                        this.appService.showDialog(MessageSeverity.Success, "Subscription Successful", "Thank you for subscribing to Lutz Angeles Newz and product updates.  To unsubscribe, reply STOP or HELP for more options", "", "CLOSE", false, false, false);

                    } else {

                        this.appService.showDialog(MessageSeverity.Error, "Not Subscribed", r.InitialRegistrationFailureReason!, "", "CANCEL", false, false, false);
                    }
                }
            });

        } else {

            this.appService.showDialog(MessageSeverity.Warning, "Invalid Phone Number", "The phone number entered " + this._phoneNumber + " is not a valid number.  Please check the number and try again.", "", "CANCEL", false, false, false);
        }

        return result;
    }

    public goToTermsOfUse = (): void => {

        this.appService.navigateTo("read/terms-of-use", "");
        this.closeContainerRequest.emit();
    }

    public goToPrivacyPolicy = (): void => {

        this.appService.navigateTo("read/privacy-policy", "");
        this.closeContainerRequest.emit();
    }
}
